import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services-section',
  imports: [RouterLink],
  templateUrl: './services-section.html',
  styleUrl: './services-section.css',
})
export class ServicesSection {}
